import React, { useState } from "react";
import config from "../../../config/domain";
import { NavLink } from "react-router-dom";
import { RoutesUrl } from "../../Routes/constents";

const HeaderUnauth = ({ isNavbar, showNavbar }) => {
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menuName) => {
    setOpenMenu((prev) => (prev === menuName ? null : menuName));
  };

  const closeMenu = () => {
    setOpenMenu(null);
  };

  const handleMenuKeyDown = (e) => {
    if (e.key !== "Tab" || !isNavbar) return;

    const closeButton = document.querySelector(".nav-toggle-btn");
    const menuElements = Array.from(document.querySelectorAll(
      ".mobileView a, .mobileView button, .mobileView [tabindex='0']"
    ));

    // full cycle: close button → menu items → close button
    const allFocusable = closeButton
      ? [closeButton, ...menuElements]
      : menuElements;

    if (!allFocusable.length) return;

    const firstElement = allFocusable[0];
    const lastElement = allFocusable[allFocusable.length - 1];

    // Shift + Tab on first item → move to last
    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault();
      lastElement.focus();
    }

    // Tab on last item → move to first
    if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault();
      firstElement.focus();
    }
  };

  return (
    <div className="navbar-menu">
      {/* Mobile View */}
      <div
        className={isNavbar ? "mobileView" : "hide_nav"}
        onKeyDown={handleMenuKeyDown}
      >
        <div>
          <ul onClick={showNavbar}>
            <li
              className={`nav-sub-container ${
                openMenu === "mobile-docs" ? "open" : ""
              }`}
              onMouseEnter={() => setOpenMenu("mobile-docs")}
              onMouseLeave={closeMenu}
            >
              <a
                href="javascript:void(0)"
                onClick={(e) => {
                  e.preventDefault();
                  toggleMenu("mobile-docs");
                }}
                onFocus={() => setOpenMenu("mobile-docs")}
              >
                Documentation
              </a>

              <ul className="nav-sublink">
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={config.jmw_client_docs}
                  >
                    Client Documentation
                  </a>
                </li>

                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={config.jmw_partner_docs}
                  >
                    Partner Documentation
                  </a>
                </li>
              </ul>
            </li>

            <li>
              <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
                Resources
              </NavLink>
            </li>

            <li>
              <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
                Support
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

      {/* Desktop View */}
      <ul className="destopView">
        <li
          className={`nav-sub-container ${
            openMenu === "docs" ? "open" : ""
          }`}
          onMouseEnter={() => setOpenMenu("docs")}
          onMouseLeave={closeMenu}
        >
          <a
            href="javascript:void(0)"
            onClick={(e) => {
              e.preventDefault();
              toggleMenu("docs");
            }}
            onFocus={() => setOpenMenu("docs")}
          >
            Documentation
          </a>

          <ul className="nav-sublink">
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href={config.jmw_client_docs}
              >
                Client Documentation
              </a>
            </li>

            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href={config.jmw_partner_docs}
              >
                Partner Documentation
              </a>
            </li>
          </ul>
        </li>

        <li>
          <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
            Resources
          </NavLink>
        </li>

        <li>
          <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
            Support
          </NavLink>
        </li>

        <li>
          <NavLink
            exact
            activeClassName="active"
            to={RoutesUrl.Signup}
            className="btn"
          >
            Sign-up
          </NavLink>
        </li>

        <li
          className={`noRightMargin nav-sub-container ${
            openMenu === "login" ? "open" : ""
          }`}
          onMouseEnter={() => setOpenMenu("login")}
          onMouseLeave={closeMenu}
        >
          <a
            href="javascript:void(0)"
            className="border-btn"
            onClick={(e) => {
              e.preventDefault();
              toggleMenu("login");
            }}
            onFocus={() => setOpenMenu("login")}
          >
            Login
          </a>

          <ul className="nav-sublink">
            <li>
              <NavLink to={RoutesUrl.ClientLogin}>Client Login</NavLink>
            </li>

            <li>
              <NavLink to={RoutesUrl.VendorLogin}>Partner Login</NavLink>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default HeaderUnauth;